export default __webpack_public_path__ + "static/05-8e265d7a949718a3370892df9c38839c.png";